"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_orchestration_1 = require("owa-options-orchestration");
var owa_options_orchestration_2 = require("owa-options-orchestration");
var owa_options_store_1 = require("owa-options-store");
var mobx_react_1 = require("mobx-react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var owa_options_core_1 = require("owa-options-core");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var styles = require('./OptionsFull.scss');
var SettingsFormHeader = /** @class */ (function (_super) {
    tslib_1.__extends(SettingsFormHeader, _super);
    function SettingsFormHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SettingsFormHeader.prototype.render = function () {
        var store = owa_options_store_1.getStore();
        var selectedSubCategory = this.props.selectedSubCategory;
        var isDisabled = store.isSaving ||
            store.currentSubCategoryState !== 1 /* Loaded */ ||
            !this.isFormDirty();
        return (React.createElement("div", { className: styles.settingsHeader },
            React.createElement("div", { className: styles.settingsTitle, role: "heading", "aria-level": 3 }, owa_options_strings_1.default[selectedSubCategory.titleStringKey] || ''),
            React.createElement("div", { className: styles.settingsHeaderButtons },
                store.isSaving && (React.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.large, className: styles.spinner })),
                !this.hideSaveDiscard() && [
                    React.createElement(Button_1.PrimaryButton, { text: owa_options_strings_1.default.optionsFull_save, disabled: isDisabled || this.shouldDisableSaveButton(), onClick: owa_options_orchestration_2.saveOptions, key: "save" }),
                    React.createElement(Button_1.DefaultButton, { text: owa_options_strings_1.default.optionsFull_cancel, disabled: isDisabled, onClick: owa_options_orchestration_2.discardOptions, key: "discard" }),
                ],
                React.createElement(Button_1.IconButton, { iconProps: {
                        iconName: "Cancel" /* Cancel */,
                    }, onClick: this.hide }))));
    };
    SettingsFormHeader.prototype.hide = function () {
        owa_options_orchestration_1.hideFullOptions();
    };
    SettingsFormHeader.prototype.isFormDirty = function () {
        var selectedSubCategory = this.props.selectedSubCategory;
        return owa_options_core_1.isAnyOptionDirty(selectedSubCategory);
    };
    SettingsFormHeader.prototype.hideSaveDiscard = function () {
        var selectedSubCategory = this.props.selectedSubCategory;
        return owa_options_core_1.hideSaveDiscardButtons(selectedSubCategory);
    };
    SettingsFormHeader.prototype.shouldDisableSaveButton = function () {
        var selectedSubCategory = this.props.selectedSubCategory;
        return owa_options_core_1.shouldDisableSaveButton(selectedSubCategory);
    };
    SettingsFormHeader = tslib_1.__decorate([
        mobx_react_1.observer
    ], SettingsFormHeader);
    return SettingsFormHeader;
}(React.Component));
exports.default = SettingsFormHeader;
//# sourceMappingURL=SettingsFormHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/components/full/SettingsFormHeader.js
// module id = 5310
// module chunks = 2